// extracted by mini-css-extract-plugin
export default {"printReview":"Submit-module__printReview--L2RKY"};